import React, { forwardRef } from "react";
import { TableCell, TableRow } from "@mui/material";

import { useNavigate } from "react-router";
import MenuComponent, { MenuItem } from "components/MenuComponent";
import { hasPermission } from "core/utils/roles";
import { Roles } from "../../model";

interface TableRowProps {
  row: Roles;
  attributes: { [key: string]: any };
}

const UserRolesRow = forwardRef<HTMLTableRowElement, TableRowProps>((props) => {
  const navigate = useNavigate();
  const row = props.row;
  const attributes = props.attributes;

  const options: MenuItem[] = [
    {
      label: hasPermission("update:roles")
        ? "Edit Roles"
        : "View Roles",
      onClick: () => navigate(`/security/roles/add-edit/${row.id}`),
    },
    {
      label: hasPermission("update:roles")
        ? "Edit Permissions"
        : "View Permissions",
      onClick: () => navigate(`/security/roles/permissions/${row.id}`),
    },
  ];

  return (
    <React.Fragment>
      <TableRow
        sx={{ borderBottom: "none", "& > *": { borderBottom: "unset" } }}
      >
        <TableCell>{row?.name}</TableCell>
        <TableCell>{row?.description}</TableCell>
        <TableCell>{row?.customer_id}</TableCell>
        <TableCell>{row?.role_rank}</TableCell>
        <TableCell>
          {row?.created_at &&
            new Date(row.created_at).toLocaleString("en-US", {
              year: "numeric",
              month: "short",
              day: "numeric",
              hour: "numeric",
              minute: "2-digit",
              hour12: true,
            })}
        </TableCell>
        <TableCell>
          <MenuComponent options={options} />
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
});

export default UserRolesRow;
